<template>
  <v-container>
    <v-row class="text-left">
      <v-col>
        <v-btn icon @click="$router.replace('/STOREROOM')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1">
        <v-btn icon @click="getVendors">
          <v-icon>mdi-sync</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
    <br />
    <v-data-table
      :headers="headers"
      :items="VENDORS"
      :search="search"
      :items-per-page="10"
      class="elevation-1"
    >
      <template v-slot:item.phone="{ item }">
        <p>{{ item.phone + (item.phone2 != null ? "/" + item.phone2 : "") }}</p>
      </template>
      <template v-slot:item.id="{ item }">
        <v-btn dark @click="getStock(item)">update stock</v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="newStock" persistent scrollable max-width="70%">
      <v-card>
        <v-form ref="form">
          <v-card-title>
            <span class="headline">NEW STOCK</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <template v-if="tab1">
                <v-row>
                  <v-col>
                    <v-text-field
                      label="INVOICE NUMBER"
                      required
                      v-model="invoiceNumber"
                      :rules="[RULES.required]"
                    ></v-text-field>
                    <v-text-field
                      label="INVOICE TOTAL ₹"
                      required
                      v-model="invoiceRate"
                      :rules="[RULES.required, RULES.mrp]"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <label>INVOICE DATE</label>
                    <v-date-picker v-model="indate" color="primary1"></v-date-picker>
                  </v-col>
                </v-row>
              </template>
              <template v-else-if="tab2">
                <span class="red--text">*leave both the column blank if there is no stock</span>
                <v-simple-table height="300px">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">ITEM NAME</th>
                        <th class="text-left">CATEGORY</th>
                        <th class="text-left">MRP</th>
                        <th class="text-left">BOUGHT</th>
                        <th class="text-left">STOCK</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in VENDOR_PRODUCTS" :key="index">
                        <td>{{ item.name }}</td>
                        <td>{{ item.category }}</td>
                        <td>
                          <v-text-field label="MRP  ₹" required v-model="item.newStockRate"></v-text-field>
                        </td>
                        <td>
                          <v-text-field label="BOUGHT ₹" required v-model="item.bought_rate"></v-text-field>
                        </td>
                        <td>
                          <v-text-field label="Qty" required v-model="item.newStock"></v-text-field>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template>
            </v-container>
          </v-card-text>
        </v-form>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn color="error" block @click="newStock = false">Close</v-btn>
            </v-col>
            <template v-if="tab2">
              <v-col>
                <v-btn dark block @click="tab1 = true;tab2 =false">BACK</v-btn>
              </v-col>
            </template>
            <v-col>
              <template v-if="tab1">
                <v-btn dark block @click="tab2 = true;tab1 =false">NEXT</v-btn>
              </template>
              <template v-else>
                <v-btn color="primary1" block dark @click="newStockAdd">ADD</v-btn>
              </template>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      search: "",
      tab1: true,
      tab2: false,
      invoiceNumber: "",
      indate: "",
      invoiceRate: 0,
      newStock: false,
      headers: [
        {
          text: "Vendor Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: "Phone",
          align: "start",
          sortable: false,
          value: "phone",
        },
        {
          text: "GSTIN",
          align: "start",
          sortable: false,
          value: "gstin",
        },
        {
          text: "Shop Address",
          align: "start",
          sortable: false,
          value: "address",
        },
        {
          text: "ACTIONS",
          align: "center",
          sortable: false,
          value: "id",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["VENDORS", "RULES", "VENDOR_PRODUCTS", "STOCKROOM"]),
  },
  methods: {
    ...mapActions(["GET_VENDORS", "GET_PRODUCT_LIST", "ADD_NEW_STOCK"]),
    getVendors() {
      this.$store.commit("SET_LOADING", true);
      this.GET_VENDORS().then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
    getStock(item) {
      this.$store.commit("SET_LOADING", true);
      this.GET_PRODUCT_LIST({ id: item.id }).then(() => {
        this.newStock = true;
        this.$store.commit("SET_LOADING", false);
      });
    },
    newStockAdd() {
      if (
        this.invoiceNumber != "" &&
        this.invoiceRate >= 1 &&
        this.indate != ""
      ) {
        let prodList = [];
        this.VENDOR_PRODUCTS.forEach((el) => {
          if (
            el.newStockRate != "" &&
            el.newStockRate != undefined &&
            el.newStock != "" &&
            el.newStock != undefined &&
            el.bought_rate != "" &&
            el.bought_rate != undefined
          ) {
            prodList.push({
              pid: el.id,
              mrp: el.newStockRate,
              stock: el.newStock,
              rate: el.newStockRate,
              bought_rate: el.bought_rate,
            });
          }
        });
        let invoice = {
          no: this.invoiceNumber,
          rate: this.invoiceRate,
          date: this.indate,
        };
        if (prodList.length >= 1) {
          console.log(prodList, invoice);
          this.$store.commit("SET_LOADING", true);
          this.ADD_NEW_STOCK({
            prodList,
            invoice,
          }).then(() => {
            this.newStock = false;
            this.tab1 = true;
            this.tab2 = false;
            this.invoiceNumber = "";
            this.indate = "";
            this.invoiceRate = 0;
            this.$store.commit("SET_LOADING", false);
          });
        } else {
          this.$store.commit("SET_INFO", "No Stock Added");
        }
      } else {
        this.$store.commit("SET_INFO", "Fill all Data");
      }
    },
  },
};
</script>

<style>
</style>